import { render, staticRenderFns } from "./CompanyEditWrapper.vue?vue&type=template&id=8bbf0f24&scoped=true&"
import script from "./CompanyEditWrapper.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyEditWrapper.vue?vue&type=style&index=0&id=8bbf0f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbf0f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bbf0f24')) {
      api.createRecord('8bbf0f24', component.options)
    } else {
      api.reload('8bbf0f24', component.options)
    }
    module.hot.accept("./CompanyEditWrapper.vue?vue&type=template&id=8bbf0f24&scoped=true&", function () {
      api.rerender('8bbf0f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditWrapper.vue"
export default component.exports